<div no-padding class="uploaded-imgs">
  <div class="img-node" (click)="onCaptureClick()" *ngIf="showCapture">
    <div class="camera-icon">
      <ion-icon color="dark" size="small" name="camera"></ion-icon>
    </div>
  </div>

  <div class="img-node" *ngFor="let img of docList">
    <ion-button
      *ngIf="showDelete"
      (click)="deleteImg(img)"
      size="small"
      fill="clear"
      no-box-shadow
    >
      <ion-icon size="small" name="close-circle" color="medium"></ion-icon>
    </ion-button>
    <img (click)="onImageClick(img)" [src]="img?.url" />
  </div>
</div>
